import { Bell } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiGet } from '../api/client.js';

export function NotificationBell(): JSX.Element {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    const tick = (): void => {
      apiGet<{ unreadCount: number }>('/api/notifications?unread_only=true')
        .then((r) => setUnread(r.unreadCount))
        .catch(() => {
          /* ignore polling errors */
        });
    };
    tick();
    const id = setInterval(tick, 60_000);
    return () => clearInterval(id);
  }, []);
  return (
    <Link
      to="/notifications"
      aria-label="Notifications"
      style={{
        position: 'relative',
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 34,
        height: 34,
        borderRadius: 'var(--radius-md)',
        color: 'var(--c-text-secondary)',
      }}
    >
      <Bell size={18} strokeWidth={2} />
      {unread > 0 && (
        <span
          style={{
            position: 'absolute',
            top: 4,
            right: 4,
            background: 'var(--c-danger)',
            color: '#fff',
            fontSize: 9,
            borderRadius: 99,
            padding: '1px 5px',
            fontWeight: 700,
            minWidth: 16,
            textAlign: 'center',
            lineHeight: 1.3,
          }}
        >
          {unread}
        </span>
      )}
    </Link>
  );
}
